import { FC, useEffect, useState } from 'react';

import { ClientType } from '__generated__/GQL';
import SunshineModal from 'components/_core/SunshineModal';
import { useModal } from 'components/ModalProvider/hooks';

import { useGetClient } from '../../hooks/useGetClient';
import { ClientModalContextState } from '../Modals';
import {
  ClientForm,
  ClientModalContext,
  DEFAULT_CLIENT,
} from './hooks/useClientFormModalContext';
import IndividualForm from './IndividualForm';
import OrganizationForm from './OrganizationForm';

interface ClientFormModalProps {
  client: ClientModalContextState['client'];
}

// Form in modal to create or edit a client

const ClientFormModal: FC<ClientFormModalProps> = ({ client: propsClient }) => {
  const { client: clientData } = useGetClient(propsClient?.clientId);

  const [isClientOrganization, setIsClientOrganization] =
    useState<boolean>(true);
  const [client, setClient] = useState(DEFAULT_CLIENT);

  useEffect(() => {
    if (!clientData) {
      return;
    }
    setClient(clientData as ClientForm);
    setIsClientOrganization(clientData.type === ClientType.Organization);
  }, [clientData]);

  const { hideModal } = useModal();

  return (
    <ClientModalContext.Provider
      value={{
        client,
        isClientOrganization,
        setClient,
        setIsClientOrganization,
      }}
    >
      <SunshineModal isOpen onClose={hideModal}>
        {isClientOrganization ? (
          <OrganizationForm />
        ) : (
          <IndividualForm
            shouldAutoFill={clientData?.type === ClientType.PrivateIndividual}
          />
        )}
      </SunshineModal>
    </ClientModalContext.Provider>
  );
};

export default ClientFormModal;
